import React, { useState, useEffect, useRef } from 'react';
import {
  Facebook,
  Instagram,
  Twitter,
  ArrowDown,
  EnvelopeFill,
  GeoAltFill,
} from 'react-bootstrap-icons';
import './Menu.css';
import Logo from '../../assets/logo_front.png';
import LogoMinistria from '../../assets/logo_ministria.png';
import ModalSignUp from '../Modal/ModalSignUp';
import ModalLogin from '../Modal/ModalLogin';
import { Link as ReactScrollLink } from 'react-scroll';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  cleanSignUpOrgError,
  doLogout,
  changeToken,
  changeLanguage,
} from '../../store/actions/actions';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import jwt from 'jsonwebtoken';

const Menu = ({ onClickMenu }) => {
  const [modal, setModal] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [example, setExample] = useState(false);
  const token = useSelector(({ token }) => token?.token);

  const confirmed = useSelector(({ login }) => login?.user);
  const history = useHistory();
  const dispatch = useDispatch();
  const toggle = () => {
    dispatch(cleanSignUpOrgError());
    setModal(!modal);
  };
  const handleLogOut = () => {
    dispatch(doLogout());
    dispatch(changeToken('DELETE_TOKEN'));
    // history.push('/login');
    // this.props.history.push('/login');
  };

  let role = 2;
  if (token) {
    const decodedToken = jwt.decode(token);
    role = decodedToken.role;
  }

  const loginToggle = () => setLoginModal(!loginModal);
  const { t, i18n } = useTranslation([]);
  const changeLang = (val) => {
    i18n.changeLanguage(val);
    dispatch(changeLanguage(val));
  };
  return (
    <div>
      <div style={{ backgroundColor: '#FE9900', width: '100%' }}>
        <div className='container-xxl d-flex justify-content-end align-items-center'>
          <a onClick={() => changeLang('en')} className='py-2 px-2 HomePage-prenav-anchors'>
            EN /
          </a>
          <a onClick={() => changeLang('sq')} className='py-2 px-3 HomePage-prenav-anchors'>
            SQ /
          </a>
          <a onClick={() => changeLang('sr')} className='py-2 px-3 HomePage-prenav-anchors'>
            SR
          </a>
          <a className='px-2' href='https://www.facebook.com/kosovovolunteers/'>
            <Facebook className='HomePage-prenav-anchors' size={20} />
          </a>
          <a className='px-2' href='https://www.facebook.com/kosovovolunteers/'>
            <Instagram className='HomePage-prenav-anchors' size={20} />
          </a>
          <a className='px-2' href='https://twitter.com/KosInnovations'>
            <Twitter className='HomePage-prenav-anchors' size={20} />
          </a>
        </div>
      </div>
      <nav className='navbar navbar-expand-lg navbar-light bg-light HomePage-nav'>
        <div className='container-xxl'>
          <Link className='navbar-brand' to='/login'>
            <img src={Logo} alt='front_logo' width={80} height={80} />
          </Link>
          <button
            className='navbar-toggler'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarNavDropdown'
            aria-controls='navbarNavDropdown'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button>
          <div
            className='collapse navbar-collapse sticky-top justify-content-end'
            id='navbarNavDropdown'
          >
            <ul className='navbar-nav'>
              <li className='nav-item pe-3 dropdown'>
                <Link
                  onClick={onClickMenu}
                  className='nav-link dropdown-toggle'
                  to='/resources'
                  id='navbarResourcesLink'
                  role='button'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                  style={{ fontSize: '18px' }}
                >
                  {t('Menu.firstLink')}
                </Link>
                <ul className='dropdown-menu' aria-labelledby='navbarResourcesLink'>
                  <li>
                    <Link className='dropdown-item' style={{ fontSize: '17px' }} to='/resources'>
                      {t('Menu.firstLinkOptions.optionOne')}
                    </Link>
                  </li>
                  <li>
                    <Link className='dropdown-item' style={{ fontSize: '17px' }} to='/resources'>
                      {t('Menu.firstLinkOptions.optionTwo')}
                    </Link>
                  </li>
                  <li>
                    <Link className='dropdown-item' style={{ fontSize: '17px' }} to='/resources'>
                      {t('Menu.firstLinkOptions.optionThree')}
                    </Link>
                  </li>
                  <li>
                    <Link className='dropdown-item' style={{ fontSize: '17px' }} to='/resources'>
                      {t('Menu.firstLinkOptions.optionFour')}
                    </Link>
                  </li>
                  <li>
                    <Link className='dropdown-item' style={{ fontSize: '17px' }} to='/resources'>
                      {t('Menu.firstLinkOptions.optionFive')}
                    </Link>
                  </li>
                  <li>
                    <Link className='dropdown-item' style={{ fontSize: '17px' }} to='/resources'>
                      {t('Menu.firstLinkOptions.optionSix')}
                    </Link>
                  </li>
                </ul>
              </li>
              <li className='nav-item pe-3'>
                <ReactScrollLink
                  className='nav-link'
                  to='aboutUs'
                  style={{ fontSize: '18px', cursor: 'pointer' }}
                  spy={true}
                  smooth={true}
                  offset={50}
                  duration={500}
                >
                  {t('Menu.secondLink')}
                </ReactScrollLink>
              </li>
              <li className='nav-item pe-3'>
                <ReactScrollLink
                  className='nav-link'
                  to='contactUs'
                  style={{ fontSize: '18px', cursor: 'pointer' }}
                  spy={true}
                  smooth={true}
                  offset={50}
                  duration={500}
                >
                  {t('Menu.thirdLink')}
                </ReactScrollLink>
              </li>
              <li className='nav-item pe-3'>
                <Link className='nav-link' to='/publicmentors' style={{ fontSize: '18px' }}>
                  {t('Menu.fourthLink')}
                </Link>
              </li>
              {token && confirmed && confirmed.confirmedAccount ? (
                <li className='nav-item dropdown'>
                  <a
                    className='nav-link dropdown-toggle'
                    id='navbarDropdownMenuLink'
                    role='button'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                    style={{ fontSize: '18px', color: '#fe9900' }}
                  >
                    {t('Menu.seventhLink')}
                  </a>
                  <ul className='dropdown-menu' aria-labelledby='navbarDropdownMenuLink'>
                    <li>
                      <ReactScrollLink
                        className='dropdown-item'
                        style={{ fontSize: '17px' }}
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                        onClick={() => {
                          if (role === 1) history.push('/opportunities');
                          else if (role === 2) history.push('/organisationProfile');
                          else if (role === 3) history.push('/volunteerProfile');
                          else history.push('/opportunities');
                        }}
                      >
                        Dashboard
                      </ReactScrollLink>
                    </li>
                    <li>
                      <button
                        className='dropdown-item'
                        style={{ fontSize: '17px' }}
                        onClick={(e) => {
                          e.preventDefault();
                          handleLogOut();
                        }}
                      >
                        {t('Menu.eighthlink')}
                      </button>
                    </li>
                  </ul>
                </li>
              ) : (
                <>
                  <li className='nav-item dropdown'>
                    <a
                      className='nav-link dropdown-toggle'
                      id='navbarDropdownMenuLink'
                      role='button'
                      data-bs-toggle='dropdown'
                      aria-expanded='false'
                      style={{ fontSize: '18px', color: '#fe9900' }}
                    >
                      {t('Menu.fifthLink')}
                    </a>
                    <ul className='dropdown-menu' aria-labelledby='navbarDropdownMenuLink'>
                      <li>
                        <ReactScrollLink
                          className='dropdown-item'
                          to='signupVol'
                          style={{ fontSize: '17px' }}
                          spy={true}
                          smooth={true}
                          offset={50}
                          duration={500}
                        >
                          {t('Menu.fifthLinkOptions.fifthOptionOne')}
                        </ReactScrollLink>
                      </li>
                      <li>
                        <button
                          className='dropdown-item'
                          style={{ fontSize: '17px' }}
                          onClick={toggle}
                        >
                          {t('Menu.fifthLinkOptions.fifthOptionTwo')}
                        </button>
                      </li>
                    </ul>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      style={{
                        fontSize: '18px',
                        color: '#fe9900',
                        border: 0,
                        backgroundColor: 'transparent',
                      }}
                      onClick={loginToggle}
                    >
                      {t('Menu.sixthLink')}
                    </button>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>
      <ModalSignUp modal={modal} toggle={toggle} />
      <ModalLogin modal={loginModal} toggle={loginToggle} />
    </div>
  );
};

export default Menu;
